#import "./ContractFields.graphql"

mutation ReadContractDocumentAgain($id: ID!) {
  readContractDocumentAgain(input: { id: $id }) {
    contract {
      ...ContractFields
    }
  }
}
